import {
  recordSignupModalCtaClick,
  recordSignupModalRender,
} from '@jusbrasil-web/core-next/prometheus'

import type { SignupModalCtaType } from '../components/signup-modal-header'
import type { SignupModalSegment, SignupModalVariant } from '../experiments/signup-modal'

export const SIGNUP_MODAL_CTA_TYPES = [
  'signup',
  'login',
] as const satisfies readonly SignupModalCtaType[]

export const SIGNUP_MODAL_FALLBACK_SENTINELS = ['no_entity_name', 'truncate_failed'] as const
export type SignupModalFallbackSentinel = (typeof SIGNUP_MODAL_FALLBACK_SENTINELS)[number]

export const SIGNUP_MODAL_RENDER_OUTCOMES = ['rendered', 'fallback_used'] as const
export type SignupModalRenderOutcome = (typeof SIGNUP_MODAL_RENDER_OUTCOMES)[number]

export const isSignupModalCtaType = (value: unknown): value is SignupModalCtaType =>
  typeof value === 'string' && (SIGNUP_MODAL_CTA_TYPES as readonly string[]).includes(value)

export const isSignupModalRenderOutcome = (value: unknown): value is SignupModalRenderOutcome =>
  typeof value === 'string' && (SIGNUP_MODAL_RENDER_OUTCOMES as readonly string[]).includes(value)

export const isSignupModalFallbackSentinel = (
  value: unknown
): value is SignupModalFallbackSentinel =>
  typeof value === 'string' &&
  (SIGNUP_MODAL_FALLBACK_SENTINELS as readonly string[]).includes(value)

type SignupModalRenderInput = {
  variant: SignupModalVariant
  segment: SignupModalSegment
  appId: string
  inExperiment: boolean
}

const recordSignupModalRenderOutcome = async (
  input: SignupModalRenderInput,
  outcome: SignupModalRenderOutcome
) => {
  await recordSignupModalRender({
    variant: input.variant,
    segment: input.segment,
    app_id: input.appId,
    outcome,
    in_experiment: String(input.inExperiment),
  })
}

export const recordSignupModalRenderedHealth = async (input: SignupModalRenderInput) =>
  recordSignupModalRenderOutcome(input, 'rendered')

export const recordSignupModalFallbackUsedHealth = async (input: SignupModalRenderInput) =>
  recordSignupModalRenderOutcome(input, 'fallback_used')

export const recordSignupModalCtaClickedHealth = async (input: {
  variant: SignupModalVariant
  segment: SignupModalSegment
  appId: string
  ctaType: SignupModalCtaType
  inExperiment: boolean
}) => {
  await recordSignupModalCtaClick({
    variant: input.variant,
    segment: input.segment,
    app_id: input.appId,
    cta_type: input.ctaType,
    in_experiment: String(input.inExperiment),
  })
}
